import React from 'react'
import { makeStyles, Grid, CardContent, Avatar, Typography } from '@material-ui/core'
import Rating from '@material-ui/lab/Rating'
import ContactDetail from './ContactDetail'
import { AppliedJobs } from './AppliedJobs'
import { VaccinatedBadge } from './VaccinatedBadge'

const useStyles = makeStyles((theme) => {
    return {
        container: {
            [theme.breakpoints.up('sm')]: {
                width: '80%',
            },
            margin: 'auto',
            marginTop: theme.spacing(4),
            minHeight: '90vh',
        },
        root: {
            [theme.breakpoints.up('sm')]: {
                maxWidth: 345,
            },
            backgroundColor: '#ffffff',
            borderRadius: theme.spacing(1),
            width: '100%',
            overflow: 'visible',
        },
        media: {
            height: 0,
            paddingTop: '56.25%', // 16:9
        },
        header: {
            paddingBottom: theme.spacing(1),
            paddingTop: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: theme.spacing(2),
            textAlign: 'center',
        },
        content: {
            padding: theme.spacing(0),
            paddingBottom: theme.spacing(1),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
        avatar: {
            width: 60,
            height: 60,
        },
        borderBox: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            border: 'solid 1px #E5E7EB',
            width: '100%',
        },
        workerName: {
            fontSize: '1.5rem',
            fontWeight: 'bold',
        },
        workerType: {
            fontSize: '1rem',
        },
    }
})

function ProfileSummary({ worker }) {
    const classes = useStyles()

    const { name, rating, contactDetails, workerType, vaccination, pp } = worker
    return (
        <Grid item xs={12} sm={4} className={classes.item}>
            <article className={classes.root} variant="outlined">
                <header className={classes.header}>
                    <Avatar aria-label="profile picture" className={classes.avatar} src={pp} />
                    <Typography className={classes.workerName} variant="h1" component="p">
                        {name}
                    </Typography>
                    <Typography className={classes.workerType} variant="h2" component="p" color="textSecondary">
                        {workerType}
                    </Typography>
                </header>

                <CardContent className={classes.content}>
                    {/* <ActionIcons /> */}
                    <Rating name="read-only" value={parseInt(rating)} readOnly size="small" />
                    <VaccinatedBadge vaccination={vaccination} />
                    <div className={classes.borderBox}>
                        <AppliedJobs worker={worker} />
                    </div>
                    <ContactDetail contactDetails={contactDetails} />
                </CardContent>
            </article>
        </Grid>
    )
}

export default ProfileSummary
